/* Capitol style — form liên hệ (sections/gv-contact.liquid): kiểm tra lỗi ngay trên trang giống GovMint + đếm ký tự. */
(function () {
  var me = document.getElementById('gvct-js');
  var T = {
    req: (me && me.dataset.req) || 'This is a required field.',
    email: (me && me.dataset.email) || 'Please enter a valid email address.',
    same: (me && me.dataset.same) || 'Please enter the same value again.'
  };
  var RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  document.querySelectorAll('[data-gvct-form]').forEach(function (form) {
    form.setAttribute('novalidate', '');
    var body = form.querySelector('[data-gvct-body]');
    var count = form.querySelector('[data-gvct-count]');
    var email = form.querySelector('[data-gvct-email]');
    var conf = form.querySelector('[data-gvct-confirm]');
    var tried = false;
    if (body && count) {
      var upd = function () { count.textContent = body.value.length; };
      body.addEventListener('input', upd); upd();
    }
    function msgFor(el) {
      var v = el.type === 'checkbox' ? el.checked : el.value.trim();
      if (el.required && !v) return T.req;
      if (el.type === 'email' && v && !RE.test(v)) return T.email;
      if (el === conf && email && v && v.toLowerCase() !== email.value.trim().toLowerCase()) return T.same;
      return '';
    }
    function show(el, m) {
      var f = el.closest('.gvct__field');
      var e = f.querySelector('.gvct__err');
      if (!m) {
        if (e) e.remove();
        el.removeAttribute('aria-invalid');
        return true;
      }
      if (!e) {
        e = document.createElement('div');
        e.className = 'gvct__err';
        e.id = el.id + '-err';
        f.appendChild(e);
      }
      e.textContent = m;
      el.setAttribute('aria-invalid', 'true');
      var d = (el.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
      if (d.indexOf(e.id) < 0) { d.push(e.id); el.setAttribute('aria-describedby', d.join(' ')); }
      return false;
    }
    var fields = Array.prototype.slice.call(form.querySelectorAll('input:not([type=hidden]),textarea'));
    fields.forEach(function (el) {
      var ev = el.type === 'checkbox' ? 'change' : 'blur';
      el.addEventListener(ev, function () { if (tried || el.value) show(el, msgFor(el)); });
      el.addEventListener('input', function () { if (el.getAttribute('aria-invalid')) show(el, msgFor(el)); });
    });
    form.addEventListener('submit', function (e) {
      tried = true;
      var first = null;
      fields.forEach(function (el) { if (!show(el, msgFor(el)) && !first) first = el; });
      if (first) { e.preventDefault(); first.focus(); return; }
      var b = form.querySelector('.gvct__btn');
      if (b) setTimeout(function () { b.disabled = true; }, 0);
    });
    window.addEventListener('pageshow', function () { var b = form.querySelector('.gvct__btn'); if (b) b.disabled = false; });
    var done = form.querySelector('[data-gvct-done]');
    if (done) {
      // Shopify thêm #id-form vào link sau khi gửi → trình duyệt tự nhảy tới form sau khi tải xong và làm mất focus; đợi xong rồi mới đưa con trỏ tới thông báo
      var go = function () { setTimeout(function () { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); }, 60); };
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
    }
  });
})();
